<template>

  <div slot="pageContent">

    <div class="listPage overflow-hidden px-3">

      <form-accordion class="mt-5" :title="$t('entities_setting_tb.cit')" :isTitleUpperCase="false">
        <b-row class="justify-content-start">
          <b-col sm="3" class="form-group" v-for="(item, index) in options" :key="index">
            <b-form-checkbox v-model="selectedValues[item.Name]" :value="1" :unchecked-value="0" :disabled="IsRVM">
              <span>{{ $t('rights.db_rights.' + item.Name) === ('rights.db_rights.' + item.Name) ? item.Name : $t('rights.db_rights.' + item.Name) }}</span>
            </b-form-checkbox>
          </b-col>
          <b-col cols="4" lg="3" xl="3">
            <b-button class="mr-3 justify-item-end responsive-button" v-if="!IsRVM"
                      @click="updateConfigurationTB()" variant="primary">
              <span>{{ $t('common.sve') }}</span>
            </b-button>
            <b-button class="mr-3 justify-item-end responsive-button" v-else disabled variant="primary">
              <span>{{ $t('common.sve') }}</span>
            </b-button>
          </b-col>
        </b-row>
      </form-accordion>
    </div>
  </div>
</template>

<script>

import PageOutline from '@/components/common/PageOutline.vue'
import {errorMessageAlert} from "@/helpers/alert";

export default {
  name: 'CorporateIdentifierTypeTB',
  components: {
    'page-outline': PageOutline
  },
  props: {
  },
  computed: {
  },
  data () {
    return {
      activateSpinner: false,
      IsRVM: 0,
      options: [
        { IdCIT: "1", Name: "BICC" },
        { IdCIT: "2", Name: "LEIC" },
        { IdCIT: "3", Name: "SCHEME_NAME_CODE" },
        { IdCIT: "4", Name: "SCHEME_NAME_PROPRIETARY" }
      ],
      selectedValues: {},
      IdMessageRouting: null
    }
  },
  created () {
    this.onRefresh()
  },
  mounted () {
  },
  beforeDestroy () {
  },
  watch: {
  },
  methods: {
    onRefresh () {
      this.activateSpinner = true

      this.refreshItems()

      this.$f7.pullToRefreshDone()
    },
    updateConfigurationTB () {
      let form = {
        IdMessageRouting: this.IdMessageRouting,
        inputFileBase64: this.inputFileBase64,  // Base64 pour le fichier d'entrée
        outputFileBase64: this.outputFileBase64, // Base64 pour le fichier de sortie
      }

      this.options
          .filter(option => this.selectedValues[option.Name] === 1) // Garde ceux qui sont cochés
          .forEach(option => {
            form[option.Name] = option.IdCIT; // Ajoute au form
          })

      // Appel API
      this.$engine.firstOn().routing.message.updateConfigurationTB(form)
          .then(resp => {
            this.$f7.alert(this.$i18n.t('common.routing.config_edited'), this.$i18n.t('entities_setting_tb.updated_successfully'))
          })
          .catch(e => {
            console.error("Erreur lors de la mise à jour :", e);
            this.$f7.alert(this.$i18n.t('errors.error_label'), this.$i18n.t('entities_setting_tb.update_error'))
          });
    },
    refreshItems () {
      let that = this
      this.$engine.firstOn().routing.message.fetchTB().then(resp => {


        this.IsRVM = resp.data.isRVM == 1 ? true : false;


        if (resp.data.cit.length > 0) {

          const receivedValues = resp.data.cit.map(item => item.Name)
          this.IdMessageRouting = resp.data.cit[0].IdMessageRouting

          if (resp.data.cit[0].Name != ''){
            this.options.forEach(option => {
              this.$set(this.selectedValues, option.Name, receivedValues.includes(option.Name) ? 1 : 0);
            })
          }
        }


        that.activateSpinner = false
      })
          .catch(error => {
            that.activateSpinner = false
            errorMessageAlert(error, that)
          })
    },
  }
}
</script>
